import { render, staticRenderFns } from "./S3ConfigurationDetails.vue?vue&type=template&id=4a0956c4&"
import script from "./S3ConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./S3ConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0956c4')) {
      api.createRecord('4a0956c4', component.options)
    } else {
      api.reload('4a0956c4', component.options)
    }
    module.hot.accept("./S3ConfigurationDetails.vue?vue&type=template&id=4a0956c4&", function () {
      api.rerender('4a0956c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/S3/S3ConfigurationDetails.vue"
export default component.exports